module.exports = __webpack_public_path__ + "img/about_logo_10.38940344.png";